import React, { useEffect, useRef } from 'react';
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import { Button, Modal, Steps, Radio, Spin } from "antd";
import { setLocationData, fetchImageRequest, updateModal } from '../../../store/actions/location';
import { useDispatch, useSelector } from 'react-redux';
import mapboxgl from 'mapbox-gl';
import * as turf from '@turf/turf';
import FloorImageComponent from './floorImageComponent';
import { handleClosePopup } from './locationUtils';
import { mapboxToken, mapboxOwner, terrainId, satelliteId } from "../../../configuration";
import { addButtons, addDesignedButtons } from "../../Shipments/CreateShipments/map-utils";
const InventoryLocationView = ({ visible, closePopup, inventoryLocationData }) => {
  const dispatch = useDispatch();
  const data = inventoryLocationData || {};
  const mapContainerRef = useRef(null);
  const mapRef = useRef(null);
  const boundingBoxRef = useRef(null);
  const [boundingBox, setBoundingBox] = React.useState([[-74.533564, 40.725683], [-74.533564, 40.725683]]);
  const fetchImageResponseState = useSelector(state => state.location.location_data.fetchImageResponse);
  const location_data = useSelector((state) => state.location.location_data);
  const [floorImages, setFloorImages] = React.useState({}); // To store images for each floor
  useEffect(() => {
    dispatch(setLocationData({ ...location_data, ...inventoryLocationData }));
  }, [data]);

  useEffect(() => {
    boundingBoxRef.current = boundingBox;
  }, [boundingBox])

  useEffect(() => {
    if (!inventoryLocationData?.floors) return;
    const imageRequests = Object.values(inventoryLocationData?.floors).map((floor) => {
      return  { imageId: floor?.floorImageId, floorKey: floor?.id };
    });
    imageRequests.length > 0 && dispatch(fetchImageRequest(imageRequests));
  }, [inventoryLocationData]);

  useEffect(() => {
    dispatch(updateModal({ current_modal: 'inventoryLocationView' }));
  }, []);

  function generateCircle(center, radius) {
    return turf.circle(center, radius, {
      steps: 80,
      units: 'meters'
    });
  }

  function gethandlePoint(center, radius) {
    return turf.destination(center, radius, 90, { units: 'meters' });
  }

  const validateCoord = (coord) => {
    if (coord && Array.isArray(coord)) {
      if (!isNaN(coord[0]) && !isNaN(coord[1])) {
        if (
          coord[0] >= -180 &&
          coord[0] <= 180 &&
          coord[1] >= -90 &&
          coord[1] <= 90
        ) {
          return true;
        }
        return false;
      }
      return false;
    } else {
      return false;
    }
  };
  const AddCircleToMap = () => {
    let center = [-74.533564, 40.725683];
    if (data?.long_value && data?.lat_value) {
      center = [data?.long_value, data?.lat_value]
    }
    if (!validateCoord(center)) return;
    const radius = data?.radius || 0;
    let circle = generateCircle(center, radius);
    const handlePoint = gethandlePoint(center, radius);

    const AddLayerAndSource = () => {
      if (mapRef.current.getLayer('radius-handle-layer')) {
        mapRef.current.removeLayer('radius-handle-layer');
      }
      if (mapRef.current.getSource('radius-handle')) {
        mapRef.current.removeSource('radius-handle');
      }
      if (mapRef.current.getLayer('geofenceLayer')) {
        mapRef.current.removeLayer('geofenceLayer');
      }
      if (mapRef.current.getSource('geofence')) {
        mapRef.current.removeSource('geofence');
      }

      mapRef?.current.addSource('geofence', {
        type: 'geojson',
        data: circle
      });
      mapRef?.current?.addLayer({
        id: 'geofenceLayer',
        type: 'fill',
        source: 'geofence',
        paint: {
          'fill-color': '#088',
          'fill-opacity': 0.4
        }
      });
      mapRef?.current?.addSource('radius-handle', {
        type: 'geojson',
        data: handlePoint
      });

      mapRef?.current?.addLayer({
        id: 'radius-handle-layer',
        type: 'line',
        source: 'geofence',
        paint: {
          'line-color': '#0089EC',
          'line-width': 3,
          'line-dasharray': [3, 3]
        }
      });
    }

    if (mapRef.current.isStyleLoaded()) {
      AddLayerAndSource();
    } else {
      mapRef.current.once('styledata', () => {
        AddLayerAndSource();
      })
    }

    const boundingBox = turf.bbox(circle);
    setBoundingBox(boundingBox);
    mapRef?.current?.fitBounds(boundingBox, {
      padding: 100,
      duration: 1000
    });

  }

  useEffect(() => {
    if (!mapContainerRef.current) return;
    if (!mapboxgl.supported()) {
      console.error("WebGL is not supported in this browser. Map cannot be initialized.");
      return;
    }
    try {
      mapRef.current = new mapboxgl.Map({
        container: mapContainerRef.current,
        style: `mapbox://styles/${mapboxOwner}/${terrainId}`,
        center: [-74.533564, 40.725683],
        zoom: 6,
      });
    } catch (e) {
      console.error("Failed to initialize map:", e);
      return;
    }
    mapRef.current.addControl(new mapboxgl.NavigationControl({
      visualizePitch: true,
    }), "bottom-right");
    mapRef.current.addControl(new mapboxgl.FullscreenControl(), "top-right");
    if (data?.lat_value && data?.long_value) {
      const markerNode = document.createElement('div');
      markerNode.style.width = '20px';
      markerNode.style.height = '30px';
      markerNode.innerHTML = `<img src="/assets/destination-location.svg" style="width:20px; height:30px;" alt="destination location"/>`;
      new mapboxgl.Marker(markerNode)
        .setLngLat([data.long_value, data.lat_value])
        .addTo(mapRef.current);
    }
    const handleFullScreenChange = (e) => {
      if (mapRef.current) {
        setTimeout(() => {
          mapRef?.current?.fitBounds(boundingBoxRef.current, {
            padding: 100,
            duration: 1000
          });
        }, 100)

      }
    }
    const fullScreenEvents = [
      'fullscreenchange',
      'webkitfullscreenchange',
      'mozfullscreenchange',
      'MSFullscreenChange'
    ];
    fullScreenEvents.forEach(e => {
      document.addEventListener(e, handleFullScreenChange);
    });
    AddCircleToMap()

    return () => {
      fullScreenEvents.forEach(e => {
        document.removeEventListener(e, handleFullScreenChange);
      })
    }
  }, [mapContainerRef.current]);

  return (
    <div>
      <Modal
        title=""
        visible={visible}
        onCancel={() => { handleClosePopup({dispatch}); }}
        footer={[
          <Grid2
            container
            marginTop={0}
            marginBottom={'1.5rem'}
            spacing={2}
            columns={{ xs: 12 }}
          >
            <Grid2 item xs={12} sm={6} md={6} lg={6}>
              <div className="mb-0">
                <Button
                  className="custom-button-cancel"
                  type="default"
                  onClick={() => { handleClosePopup({dispatch}); }}
                  shape="round"
                  style={{ fontWeight: "bold", width: "100%" }}
                  size={"large"}
                >
                  Cancel
                </Button>
              </div>
            </Grid2>
            <Grid2 item xs={12} sm={6} md={6} lg={6}>
              <div className="mb-0">
                <Button
                  className="custom-button-save"
                  type="primary"
                  onClick={() => { dispatch(updateModal({ current_modal: location_data?.createtype == 'ShipmentLocation' || !location_data?.createtype ? 'ShipmentLocation' : 'inventory_location' }));dispatch(setLocationData({ ...location_data, action_type: 'edit' }));closePopup();}} //handleSubmit}
                  // onClick={() => { dispatch(setLocationData({ ...location_data, action_type: 'edit' }));setTimeout(() => dispatch(updateModal({ current_modal: 'ShipmentLocation' })), 0);closePopup();}} //handleSubmit}
                  shape="round"
                  style={{
                    width: "100%",
                    backgroundColor: "black",
                    color: "white",
                    fontWeight: "bold",
                  }}
                  size={"large"}
                >
                  Edit
                </Button>
              </div>
            </Grid2>
          </Grid2>,
        ]}
        width={680}
      >
        <div style={{ margin: '25px' }}>
          <div style={{ marginBottom: "15px", marginTop: "15px" }}>
            <h2 className={"font-face-vzb page-header-location"}>
              {data?.name}
            </h2>
          </div>
          {/* <h2 className={"font-face-vzb page-header-location"}>
            {data?.name}
          </h2> */}
          <Grid2
            container
            marginTop={1}
            marginBottom={2}
            spacing={1}
            columns={{ xs: 12 }}
          >
            <Grid2 item xs={12} sm={4}>
              <div>
                <label className='font16Location' style={{ fontWeight: "bold", fontFamily: "VerizonNHGDSBold", marginBottom: '4px' }}>Location Type</label>
                <div className='font16Location' style={{textAlign: "left"}}>{data?.createtype === 'inventory_location' ? 'Inventory Location' : 'Shipment Location'}</div>
              </div>
            </Grid2>
            <Grid2 item xs={12} sm={8}>
              <div>
                <label className='font16Location' style={{ fontWeight: "bold", fontFamily: "VerizonNHGDSBold", marginBottom: '4px' }}>Address</label>
                <div className='font16Location' style={{textAlign: "left"}}>{data?.address || 'N/A'}</div>
              </div>
            </Grid2>
          </Grid2>
          {data?.createtype !== 'inventory_location' || !data?.addfloormap?
            (
              <>
                {/* New row for latitude, longitude, geofence radius */}
                <Grid2
                  container
                  marginTop={1}
                  marginBottom={2}
                  spacing={1}
                  columns={{ xs: 12 }}
                >
                  <Grid2 item xs={12} sm={4}>
                    <div>
                      <label className='font16Location' style={{ fontWeight: "bold", fontFamily: "VerizonNHGDSBold", marginBottom: '4px' }}>Latitude</label>
                      <div className='font16Location' style={{textAlign: "left"}}>{data?.lat_value ?? 123}</div>
                    </div>
                  </Grid2>
                  <Grid2 item xs={12} sm={4}>
                    <div>
                      <label className='font16Location' style={{ fontWeight: "bold", fontFamily: "VerizonNHGDSBold", marginBottom: '4px' }}>Longitude</label>
                      <div className='font16Location' style={{textAlign: "left"}}>{data?.long_value ?? 222}</div>
                    </div>
                  </Grid2>
                  <Grid2 item xs={12} sm={4}>
                    <div>
                      <label className='font16Location' style={{ fontWeight: "bold", fontFamily: "VerizonNHGDSBold", marginBottom: '4px' }}>Geofence radius (m)</label>
                      <div className='font16Location' style={{textAlign: "left"}}>{data?.radius ?? 500}</div>
                    </div>
                  </Grid2>
                </Grid2>
                {
                  <div className={`w-100 d-flex flex-column justify-content-center align-items-start map-container ${!data?.addFloor ? 'mapContainerDisp' : 'mapContainerNotDisp'}`}>
                  <div
                    ref={mapContainerRef}
                    style={{ width: "100%", height: "364px", borderRadius: '8px' }}
                  />
                  </div>
                }
              </>
            ) : (
              <div style={{display: 'flex', flexDirection: 'column'}}>
              { location_data.floors && Object.values(location_data.floors).map((floor) => {
                return (
                  <div key={floor?.id} style={{ marginBottom: '24px', marginTop: '24px', width: '100%' }}>
                    <div className='font16Location' style={{ fontWeight: 'bold', fontFamily: 'VerizonNHGDSBold', marginBottom: '8px', textAlign: 'left' }}>
                      {floor.name}
                    </div>
                    <div style={{ width: '100%', height: '364px', borderRadius: '8px', background: '#f5f5f5', marginBottom: '12px' }}>
                      <Spin spinning={!(floor?.file instanceof Blob) && location_data?.fetchImageResponse?.[floor?.id]?.success} >
                        <FloorImageComponent floorid={floor?.id} />
                      </Spin>
                    </div>
                  </div>
                );
              })}
              </div>
            )}
        </div>
      </Modal>
    </div>
  );
};

export default InventoryLocationView;